import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import NavbarMob from "./NavbarMob";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Navbar2 from "./Navbar2";
import Select from "react-select";
import worktime from "../json/worktime.json";
import endtime from "../json/endtime.json";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar2Mob from "./Navbar2Mob";

function EditJobPost() {
    const location = useLocation();
    const navigate = useNavigate();
    const { jobId, employeeId, manualJobID: initialManualJobID, jobData } = location.state || {}; // jobData passed from navigation
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    // --- State Variables ---
    const [isLoading, setIsLoading] = useState(true); // Loading state for options
    const [isFetchingJob, setIsFetchingJob] = useState(false); // Loading state for job details
    const [isSubmitting, setIsSubmitting] = useState(false); // Prevent double submits

    // Form Fields
    const [jobTitle, setJobTitle] = useState("");
    const [minSalary, setMinSalary] = useState("");
    const [maxSalary, setMaxSalary] = useState("");
    const [qualification, setQualification] = useState(null);
    const [jobDescription, setJobDescription] = useState("");
    const [salaryType, setSalaryType] = useState(null);
    const [whatsappNumber, setWhatsappNumber] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [shopName, setShopName] = useState("");
    const [area, setArea] = useState("");
    const [manualJobID, setManualJobID] = useState("");
    const [genderType, setGenderType] = useState(null);
    const [foodType, setFoodType] = useState(null);
    const [experienceType, setExperienceType] = useState(null);
    const [vacancy, setVacancy] = useState("");

    // Dropdown Categories (Single Selection)
    const [companyCategory, setCompanyCategory] = useState(null);
    const [jobsCategory, setJobsCategory] = useState(null);
    const [startCategory, setStartCategory] = useState(null);
    const [endCategory, setEndCategory] = useState(null);

    // Multi Selection
    const [locationCategory, setLocationCategory] = useState([]);

    // Options Lists
    const [locationOptions, setLocationOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [jobsOptions, setJobsOptions] = useState([]);
    const [degreeOptions, setDegreeOptions] = useState([]);
    const [startOptions, setStartOptions] = useState([]);
    const [endOptions, setEndOptions] = useState([]);

    const [errorState, setErrorState] = useState({}); // Validation Errors

    const customertype = sessionStorage.getItem("customerType");
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    if (!jobId || !employeeId) {
        console.error("Missing jobId or employeeId");
        // valid redirect could go here if needed
    }

    // --- Static Options ---
    const genderTypeOptions = [
        { value: "MALE", label: "MALE" },
        { value: "FEMALE", label: "FEMALE" },
        { value: "MALE/FEMALE", label: "MALE/FEMALE" },
    ];

    const foodTypeOptions = [
        { value: "No", label: "No" },
        { value: "Yes", label: "Yes" },
        { value: "Accomodation Only", label: "Accomodation Only" },
        { value: "Food Only", label: "Food Only" },
    ];

    const experienceOptions = [
        { value: "Fresher", label: "Fresher" },
        { value: "Experienced", label: "Experienced" },
        { value: "Any", label: "Any" },
    ];

    const salaryOptions = [
        { value: "Negotiable", label: "Negotiable" },
        { value: "On Work Basis", label: "On Work Basis" },
    ];

    const customStyles = {
        control: (provided) => ({
            ...provided,
            height: "43px",
            border: "2px solid #D7D7D7",
            borderRadius: "5px",
            paddingLeft: "4px",
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: "5px",
        }),
    };

    // --- 1. Fetch All Options (Synchronized) ---
    useEffect(() => {
        window.scrollTo(0, 0);

        const fetchAllOptions = async () => {
            setIsLoading(true);
            try {
                // 1. Static JSON Options
                const workstart = worktime.states[0].districts.map((d) => ({ value: d, label: d }));
                const workend = endtime.states[0].districts.map((d) => ({ value: d, label: d }));
                setStartOptions(workstart);
                setEndOptions(workend);

                // 2. Parallel Fetching for API Options
                const [locRes, compRes, jobsRes, qualRes] = await Promise.all([
                    fetch(`${apiBaseUrl}/data`),
                    fetch(`${apiBaseUrl}/datacompany`),
                    fetch(`${apiBaseUrl}/datajobs`),
                    fetch(`${apiBaseUrl}/dataqualifications`),
                ]);

                // 3. Process Location Data
                if (locRes.ok) {
                    const locData = await locRes.json();
                    if (locData?.states?.[0]?.districts) {
                        setLocationOptions(
                            locData.states[0].districts.map((d) => ({ value: d, label: d }))
                        );
                    }
                }

                // 4. Process Company Category Data
                if (compRes.ok) {
                    const compData = await compRes.json();
                    if (compData?.states?.[0]?.districts) {
                        setCategoryOptions(
                            compData.states[0].districts.map((d) => ({ value: d, label: d }))
                        );
                    }
                }

                // 5. Process Jobs Category Data
                if (jobsRes.ok) {
                    const jobsDataRes = await jobsRes.json();
                    // Assuming structure: states[0].jobs array strings
                    if (jobsDataRes?.states?.[0]?.jobs) {
                        setJobsOptions(
                            jobsDataRes.states[0].jobs.map((j) => ({ value: j, label: j }))
                        );
                    }
                }

                // 6. Process Qualification Data
                if (qualRes.ok) {
                    const qualData = await qualRes.json();
                    if (qualData?.states?.[0]?.districts) {
                        setDegreeOptions(
                            qualData.states[0].districts.map((d) => ({ value: d, label: d }))
                        );
                    }
                }

            } catch (error) {
                console.error("Error fetching options:", error);
                alert("Failed to load form options. Please reload the page.");
            } finally {
                setIsLoading(false); // Enable Form / Trigger Job Fetch
            }
        };

        if (apiBaseUrl) {
            fetchAllOptions();
        }
    }, [apiBaseUrl]);


    // --- 2. Fetch Job Data (After Options Loaded) ---
    useEffect(() => {
        if (isLoading || !jobId) return; // WAIT until options are ready

        const fetchJobData = async () => {
            setIsFetchingJob(true);
            try {
                const response = await fetch(`${apiBaseUrl}/getjobposts/${jobId}`);
                if (!response.ok) throw new Error("Failed to fetch job details");

                const data = await response.json();
                console.log("Fetched Job Data:", data);

                // --- Populate Text Fields ---
                setJobTitle(data.job_title || "");
                setShopName(data.shopName || "");
                setArea(data.area || "");
                setMinSalary(data.min_salary || "");
                setMaxSalary(data.max_salary || "");
                setJobDescription(data.job_description || "");
                setWhatsappNumber(data.whatsapp_number || "");
                setEmail(data.email || "");
                setAddress(data.address || "");
                setVacancy(data.vacancy || "");
                setManualJobID(data.manualJobID || "");

                // --- Populate Dropdowns (Matching Options) ---

                // Location (Multi-select)
                const selectedLocs = data.location ? data.location.split(", ") : [];
                // We must filter using the *current* locationOptions reference we just set
                // Filter matches by value
                const matchedLocations = locationOptions.filter(opt => selectedLocs.includes(opt.value));
                setLocationCategory(matchedLocations);

                // Company Category
                const matchedComp = categoryOptions.find(opt => opt.value === data.company_type);
                setCompanyCategory(matchedComp || null);

                // Job Category
                const matchedJob = jobsOptions.find(opt => opt.value === data.job);
                setJobsCategory(matchedJob || null);

                // Qualification
                const matchedQual = degreeOptions.find(opt => opt.value === data.qualification);
                setQualification(matchedQual || null);

                // Start/End Time
                const matchedStart = startOptions.find(opt => opt.value === data.start_time);
                setStartCategory(matchedStart || null);

                const matchedEnd = endOptions.find(opt => opt.value === data.end_time);
                setEndCategory(matchedEnd || null);

                // Static Options matching
                setGenderType(genderTypeOptions.find(opt => opt.value === data.gender_type) || null);
                setFoodType(foodTypeOptions.find(opt => opt.value === data.food_type) || null);
                setExperienceType(experienceOptions.find(opt => opt.value === data.experienceType) || null);
                setSalaryType(salaryOptions.find(opt => opt.value === data.salaryType) || null);

            } catch (error) {
                console.error("Error fetching job details:", error);
            } finally {
                setIsFetchingJob(false);
            }
        };

        fetchJobData();

    }, [jobId, isLoading, locationOptions, categoryOptions, jobsOptions, degreeOptions, startOptions, endOptions, apiBaseUrl]); // Dependencies ensure fresh options

    useEffect(() => {
        if (!jobsCategory?.value || !locationCategory?.length) return;

        const locationText = locationCategory.map((option) => option.value).join(", ");
        setJobTitle(`${jobsCategory.value} in ${locationText}`.toUpperCase());
    }, [jobsCategory, locationCategory]);


    // --- 3. Handle Submit with Validation ---
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) return; // Already submitting; block repeated clicks

        // VALIDATION
        const errors = {};
        if (!jobTitle) errors.jobTitle = "Job Title is required";
        if (!shopName) errors.shopName = "Shop Name is required";
        if (!genderType) errors.genderType = "Gender is required";
        if (!companyCategory) errors.companyCategory = "Company Category is required";
        if (!jobsCategory) errors.jobsCategory = "Job Category is required";
        if (!locationCategory || locationCategory.length === 0) errors.locationCategory = "Location is required";
        if (!area) errors.area = "Area is required";
        // if (!qualification) errors.qualification = "Qualification is required";
        // if (!jobDescription) errors.jobDescription = "Job Description is required";
        if (!foodType) errors.foodType = "Food Type is required";
        if (!whatsappNumber) errors.whatsappNumber = "WhatsApp Number is required";
        // if (!email) errors.email = "Email is required";
        if (!address) errors.address = "Address is required";
        // if (!experienceType) errors.experienceType = "Experience is required";
        // Number of vacancies field is hidden as requested, so this validation is kept for future reuse.
        // if (!vacancy) errors.vacancy = "Vacancy count is required";
        if (!salaryType && !minSalary && !maxSalary) errors.salary = "Salary information is required";


        if (Object.keys(errors).length > 0) {
            setErrorState(errors);
            console.log("Validation Failed:", errors);
            // Alert user with a concise list of missing fields
            const missingList = Object.values(errors).join("\n ");
            alert(`Please fill these: \n ${missingList}`);
            window.scrollTo(0, 0); // Scroll up to see errors
            return;
        }

        setIsSubmitting(true);
        setErrorState({}); // clear previous errors

        // Prepare Data
        const locationString = locationCategory.map((opt) => opt.value).join(", ");

        const formData = {
            jobId,
            employeeId,
            manualJobID: manualJobID || "",
            jobTitle: jobTitle || "",
            shopName: shopName || "",
            genderType: genderType?.value || "",
            companyType: companyCategory?.value || "",
            job: jobsCategory?.value || "",
            location: locationString,
            area: area || "",
            minSalary: minSalary ? Number(minSalary) : null,
            maxSalary: maxSalary ? Number(maxSalary) : null,
            startTime: startCategory?.value || "",
            endTime: endCategory?.value || "",
            qualification: qualification?.value || "",
            jobDescription: jobDescription || "",
            foodType: foodType?.value || "",
            whatsappNumber: whatsappNumber || "",
            email: email || "",
            address: address || "",
            experienceType: experienceType?.value || "",
            vacancy: vacancy ? Number(vacancy) : null,
            salaryType: salaryType?.value || "",
        };

        console.log("Submitting Form Data:", formData);

        try {
            const response = await fetch(`${apiBaseUrl}/jobpost/${jobId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            if (result.success) {
                alert("Job updated successfully!");
                navigate("/postedjob");
            } else {
                alert("Failed to update job: " + (result.message || "Unknown error"));
            }
        } catch (error) {
            console.error("Error updating job:", error);
            alert("An error occurred while updating.");
        } finally {
            setIsSubmitting(false);
        }
    };


    return (
        <div className="flex flex-col min-h-screen">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>
            <div className="flex justify-center items-center bg-[black] py-12">
                <div className="lg:w-[90%] w-[90%] h-[70%] bg-[white] flex flex-col items-center gap-12 py-12 lg:rounded-[20px] rounded-[5px]">
                    <span className="text-xl font-[700] font-display">Edit Job Post {isFetchingJob && "(Loading...)"}</span>

                    {isLoading ? (
                        <div className="py-20 text-center text-lg font-semibold">Loading options...</div>
                    ) : (
                        <form onSubmit={handleSubmit} className="grid lg:grid-cols-3 grid-cols-1 gap-5 lg:px-12 px-3 w-full">
                            {/* Job Title */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Job Title *</span>
                                <input
                                    placeholder="Job Title"
                                    type="text"
                                    className={`h-[43px] w-full border-2 rounded-[5px] px-4 placeholder:text-center ${errorState.jobTitle ? 'border-red-500' : 'border-[#D7D7D7]'}`}
                                    value={jobTitle}
                                    onChange={(e) => setJobTitle(e.target.value)}
                                />
                                {errorState.jobTitle && <span className="text-red-500 text-sm">{errorState.jobTitle}</span>}
                            </div>

                            {/* Job */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Job *</span>
                                <Select
                                    placeholder="Select Job"
                                    options={jobsOptions}
                                    value={jobsCategory}
                                    onChange={setJobsCategory}
                                    isClearable
                                    styles={customStyles}
                                />
                                {errorState.jobsCategory && <span className="text-red-500 text-sm">{errorState.jobsCategory}</span>}
                            </div>

                            {/* Shop Name */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Shop Name *</span>
                                <input
                                    placeholder="Shop Name"
                                    type="text"
                                    className={`h-[43px] w-full border-2 rounded-[5px] px-4 placeholder:text-center ${errorState.shopName ? 'border-red-500' : 'border-[#D7D7D7]'}`}
                                    value={shopName}
                                    onChange={(e) => setShopName(e.target.value)}
                                />
                                {errorState.shopName && <span className="text-red-500 text-sm">{errorState.shopName}</span>}
                            </div>

                            {/* Gender */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Gender *</span>
                                <Select
                                    placeholder="Select Gender"
                                    options={genderTypeOptions}
                                    value={genderType}
                                    onChange={setGenderType}
                                    isClearable
                                    styles={customStyles}
                                    classNamePrefix="react-select"
                                />
                                {errorState.genderType && <span className="text-red-500 text-sm">{errorState.genderType}</span>}
                            </div>

                            {/* Qualification */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Qualification</span>
                                <Select
                                    placeholder="Select Qualification"
                                    options={degreeOptions}
                                    value={qualification}
                                    onChange={setQualification}
                                    isClearable
                                    styles={customStyles}
                                />
                                {errorState.qualification && <span className="text-red-500 text-sm">{errorState.qualification}</span>}
                            </div>

                            {/* Min Salary */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Minimum Salary *</span>
                                <input
                                    placeholder="Minimum Salary"
                                    type="number"
                                    className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4 placeholder:text-center"
                                    value={minSalary}
                                    onChange={(e) => setMinSalary(e.target.value)}
                                />
                            </div>

                            {/* Max Salary */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Maximum Salary *</span>
                                <input
                                    placeholder="Maximum Salary"
                                    type="number"
                                    className="h-[43px] w-full border-2 border-[#D7D7D7] rounded-[5px] px-4 placeholder:text-center"
                                    value={maxSalary}
                                    onChange={(e) => setMaxSalary(e.target.value)}
                                />
                            </div>

                            {/* Salary Options */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Salary Options *</span>
                                <Select
                                    placeholder="Select Salary Options"
                                    options={salaryOptions}
                                    value={salaryType}
                                    onChange={setSalaryType}
                                    isClearable
                                    styles={customStyles}
                                />
                            </div>

                            {/* Experience */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Experience</span>
                                <Select
                                    placeholder="Select Required Experience"
                                    options={experienceOptions}
                                    value={experienceType}
                                    onChange={setExperienceType}
                                    isClearable
                                    styles={customStyles}
                                />
                                {errorState.experienceType && <span className="text-red-500 text-sm">{errorState.experienceType}</span>}
                            </div>

                            {/* Job Description */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Job Description *</span>
                                <input
                                    placeholder="Job Description"
                                    type="text"
                                    className={`h-[43px] w-full border-2 rounded-[5px] px-4 placeholder:text-center ${errorState.jobDescription ? 'border-red-500' : 'border-[#D7D7D7]'}`}
                                    value={jobDescription}
                                    onChange={(e) => setJobDescription(e.target.value)}
                                />
                                {errorState.jobDescription && <span className="text-red-500 text-sm">{errorState.jobDescription}</span>}
                            </div>

                            {/* Food Type */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Food & Accommodation *</span>
                                <Select
                                    placeholder="Select"
                                    options={foodTypeOptions}
                                    value={foodType}
                                    onChange={setFoodType}
                                    isClearable
                                    styles={customStyles}
                                />
                                {errorState.foodType && <span className="text-red-500 text-sm">{errorState.foodType}</span>}
                            </div>

                            {/* Company Category */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Company Category *</span>
                                <Select
                                    placeholder="Select Company Category"
                                    options={categoryOptions}
                                    value={companyCategory}
                                    onChange={setCompanyCategory}
                                    isClearable
                                    styles={customStyles}
                                />
                                {errorState.companyCategory && <span className="text-red-500 text-sm">{errorState.companyCategory}</span>}
                            </div>

                            {/* Location */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Job Location *</span>
                                <Select
                                    placeholder="Select Locations"
                                    options={locationOptions}
                                    value={locationCategory}
                                    onChange={setLocationCategory}
                                    isClearable
                                    isMulti
                                    styles={customStyles}
                                />
                                {errorState.locationCategory && <span className="text-red-500 text-sm">{errorState.locationCategory}</span>}
                            </div>

                            {/* Manager Number */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Manager Number *</span>
                                <input
                                    placeholder="Enter Number"
                                    type="text"
                                    className={`h-[43px] w-full border-2 rounded-[5px] px-4 placeholder:text-center ${errorState.whatsappNumber ? 'border-red-500' : 'border-[#D7D7D7]'}`}
                                    value={whatsappNumber}
                                    onChange={(e) => setWhatsappNumber(e.target.value)}
                                />
                                {errorState.whatsappNumber && <span className="text-red-500 text-sm">{errorState.whatsappNumber}</span>}
                            </div>

                            {/* Work Time fields hidden as requested. Keep these fields for future reuse.
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Work Time Start *</span>
                                <Select
                                    placeholder="Select Start Time"
                                    options={startOptions}
                                    value={startCategory}
                                    onChange={setStartCategory}
                                    isClearable
                                    styles={customStyles}
                                />
                            </div>

                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Work Time End *</span>
                                <Select
                                    placeholder="Select End Time"
                                    options={endOptions}
                                    value={endCategory}
                                    onChange={setEndCategory}
                                    isClearable
                                    styles={customStyles}
                                />
                            </div>
                            */}

                            {/* Email field hidden as requested. Keep this field for future reuse.
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Email</span>
                                <input
                                    placeholder="Email"
                                    type="email"
                                    className={`h-[43px] w-full border-2 rounded-[5px] px-4 placeholder:text-center ${errorState.email ? 'border-red-500' : 'border-[#D7D7D7]'}`}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                {errorState.email && <span className="text-red-500 text-sm">{errorState.email}</span>}
                            </div>
                            */}

                            {/* Address */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Full Address *</span>
                                <input
                                    placeholder="Enter Address"
                                    type="text"
                                    className={`h-[43px] w-full border-2 rounded-[5px] px-4 placeholder:text-center ${errorState.address ? 'border-red-500' : 'border-[#D7D7D7]'}`}
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                                {errorState.address && <span className="text-red-500 text-sm">{errorState.address}</span>}
                            </div>

                            {/* Area */}
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">Area *</span>
                                <input
                                    placeholder="Enter Area / Locality"
                                    type="text"
                                    className={`h-[43px] w-full border-2 rounded-[5px] px-4 placeholder:text-center ${errorState.area ? 'border-red-500' : 'border-[#D7D7D7]'}`}
                                    value={area}
                                    onChange={(e) => setArea(e.target.value)}
                                />
                                {errorState.area && <span className="text-red-500 text-sm">{errorState.area}</span>}
                            </div>

                            {/* Number of Vacancies field hidden as requested. Keep this field for future reuse.
                            <div className="flex flex-col gap-3">
                                <span className="text-left text-base font-[500] font-display">No. of Vacancies *</span>
                                <input
                                    type="number"
                                    placeholder="Enter No. of Vacancies"
                                    className={`h-[43px] w-full border-2 rounded-[5px] px-4 placeholder:text-center ${errorState.vacancy ? 'border-red-500' : 'border-[#D7D7D7]'}`}
                                    value={vacancy}
                                    onChange={(e) => setVacancy(e.target.value)}
                                />
                                {errorState.vacancy && <span className="text-red-500 text-sm">{errorState.vacancy}</span>}
                            </div>
                            */}

                            {/* Submit Button */}
                            <div className="flex flex-col gap-3 lg:col-span-3 justify-center items-center">
                                <button
                                    disabled={isLoading || isFetchingJob || isSubmitting}
                                    className="bg-[black] w-[25%] h-[56px] text-white py-2 rounded-[5px] hover:bg-[#E22E37] transition duration-300 font-display text-lg font-display font-[600] disabled:bg-gray-400 disabled:cursor-not-allowed"
                                >
                                    {isFetchingJob ? "Loading..." : isSubmitting ? "Updating..." : "Update Job Post"}
                                </button>
                            </div>

                        </form>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default EditJobPost;
